import Map from "./components/Map";
import { ButtonSideContextProvider } from "./context/ButtonSideContext";
import { ChooseContextProvider } from "./context/ChooseContext";
import { EarthquakeContextProvider } from "./context/EarthquakeContext";
import { MapContextProvider } from "./context/MapContext";
import { SelectEarthquakeContextProvider } from "./context/SelectEarthquakeContext";
import { ShrinkContextProvider } from "./context/ShrinkContext";

function App() {
  return (
    <ShrinkContextProvider>
      <EarthquakeContextProvider>
        <ButtonSideContextProvider>
          <SelectEarthquakeContextProvider>
            <ChooseContextProvider>
              <MapContextProvider>
                <Map />
              </MapContextProvider>
            </ChooseContextProvider>
          </SelectEarthquakeContextProvider>
        </ButtonSideContextProvider>
      </EarthquakeContextProvider>
    </ShrinkContextProvider>
  );
}

export default App;
